const HEADER_PROPERTY_NAMES = new Set(['Bezeichnung', 'Kennzeichen', 'Reihenfolgenummer']);

export function isHeaderProperty(name) {
    return HEADER_PROPERTY_NAMES.has(name);
}
